import { Drawer, Grid } from '@mui/material'
import React from 'react'

import {
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from 'components/mobile/Drawer'
import { CloseIcon, StyledButton } from 'shared'
import { useAuth } from 'utils/providers/AuthProvider'

const LogoutDrawer = ({
  isOpen,
  closeDrawer,
}: {
  isOpen: boolean
  closeDrawer: () => void
}) => {
  const { logout } = useAuth()

  return (
    <Drawer
      open={isOpen}
      anchor="bottom"
      onClose={closeDrawer}
      PaperProps={{ sx: { borderRadius: '16px 16px 0px 0px' } }}
    >
      <DrawerContent>
        <DrawerHeader>
          <DrawerTitle>Are you sure you want to log out?</DrawerTitle>
          <CloseIcon onClick={closeDrawer} />
        </DrawerHeader>
      </DrawerContent>
      <Grid container flexWrap="nowrap" gap={1} sx={{ padding: '16px' }}>
        <StyledButton variant="outlined" onClick={closeDrawer} fullWidth>
          Cancel
        </StyledButton>
        <StyledButton
          variant="contained"
          onClick={() => {
            closeDrawer()
            logout()
          }}
          fullWidth
        >
          Continue
        </StyledButton>
      </Grid>
    </Drawer>
  )
}

export default LogoutDrawer
